export default [
  {
    id: 2,
    path: "/mymedia",
    name: "应用列表",
    redirect: "/mymedia/list",
    component: resolve => require(["@/page/mymedia/index.vue"], resolve),
    meta: {
      title: "应用列表"
    },
    children: [
      {
        id: 1,
        path: "list",
        name: "list",
        component: resolve => require(["@/page/mymedia/list.vue"], resolve),
        meta: {
          title: "我的应用"
        }
      },
      {
        id: 2,
        path: "add",
        component: resolve => require(["@/page/mymedia/add.vue"], resolve),
        meta: {
          title: "新建应用"
        }
      },
      {
        //广告位列表
        id: 3,
        path: "advertising",
        name: "advertising",
        component: resolve =>
          require(["@/page/mymedia/advertising.vue"], resolve),
        meta: {
          title: "我的广告位"
        }
      },
      {
        //新建广告位
        id: 4,
        path: "addadvertising",
        name: "advertising",
        component: resolve =>
          require(["@/page/mymedia/addAdvertising.vue"], resolve),
        meta: {
          title: "新建广告位"
        }
      },
      {
        //流量质量分
        id: 5,
        path: "flowquality",
        component: resolve =>
          require(["@/page/mymedia/flowquality.vue"], resolve),
        meta: {
          title: "流量质量分"
        }
      }
    ]
  },
  {
    id: 3,
    path: "/demo",
    name: "测试输入框",
    component: resolve => require(["@/page/search-select/index.vue"], resolve)
  }
];


// WEBPACK FOOTER //
// ./src/router/media.js